import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('请输入邮箱地址');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('请输入有效的邮箱地址');
      return;
    }
    setError('');
    setSubmitted(true);
    setEmail('');
  };

  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-background-50/20 mb-5">
          <i className="ri-mail-send-line text-2xl text-background-50"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          订阅最新黑料
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto">
          第一时间获取独家爆料与深度调查报道，我们承诺绝不泄露您的个人信息。
        </p>

        {submitted ? (
          <div className="bg-background-50/15 rounded-lg py-4 px-6 inline-block">
            <p className="text-background-50 text-sm font-medium">
              <i className="ri-checkbox-circle-line mr-2"></i>
              订阅成功！感谢您的关注，最新爆料将第一时间送达。
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            data-readdy-form="true"
          >
            <div className="flex-1 relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-background-50/60 text-sm"></i>
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError('');
                }}
                placeholder="输入您的邮箱地址"
                className="w-full pl-10 pr-4 py-3 text-sm bg-background-50/15 border border-background-50/25 rounded-md text-background-50 placeholder-background-50/40 focus:outline-none focus:border-background-50/50 transition-colors"
              />
            </div>
            <button
              type="submit"
              className="px-6 py-3 text-sm font-medium bg-background-50 text-primary-600 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              立即订阅
            </button>
            {error && (
              <p className="text-xs text-background-50/80 absolute -bottom-6 left-0">{error}</p>
            )}
          </form>
        )}
      </div>
    </section>
  );
}